export default {
  SET_STATE: 'users/readers/SET_STATE',
  FETCH_READERS: 'users/readers/FETCH_READERS',
  FETCH_SINGLE_READER: 'users/readers/FETCH_SINGLE_READER',
  UPDATE_READER: 'users/readers/UPDATE_READER',
  CREATE_READER: 'users/readers/CREATE_READER',
  PERFORM_ACTION_READER: 'users/readers/PERFORM_ACTION_READER',
}
